import EmailLog from 'components/EmailLog/EmailLog'

export default EmailLog 